<h1 mat-dialog-title>
  Abertura de atendimento
</h1>

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step [stepControl]="formVeiculo.form">
    <ng-template matStepLabel>Dados do veículo</ng-template>
    <app-form [campos]="camposDadosVeiculo" appearance="outline" #formVeiculo></app-form>
  </mat-step>

  <mat-step [stepControl]="formSinistro!.form" *ngIf="formVeiculo.get('registrarSinistro') === 'S'">
    <ng-template matStepLabel>Dados do sinistro</ng-template>
    <app-form [campos]="camposDadosSinitro" appearance="outline" #formSinistro></app-form>
  </mat-step>

  <mat-step [stepControl]="formCliente.form">
    <ng-template matStepLabel>Dados do cliente</ng-template>
    <app-form [campos]="camposDadosCliente" appearance="outline" #formCliente></app-form>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Anexos</ng-template>
    <app-anexos [options]="{ hideSent: true }" #anexos></app-anexos>
  </mat-step>
</mat-horizontal-stepper>

<div mat-dialog-actions align="end">
  <button 
    type="button"
    mat-flat-button 
    (click)="stepper.previous()" 
    *ngIf="stepper.selectedIndex !== 0">
    Anterior
  </button>
  
  <button 
    type="button" 
    mat-flat-button 
    [disabled]="!stepper.selected?.stepControl?.valid"
    (click)="stepper.next()"
    *ngIf="stepper.selectedIndex < stepper.steps.length -1">
    Próximo
  </button>

  <button 
    type="submit" 
    mat-flat-button 
    [disabled]="!isFormValid"
    (click)="onSubmit(formVeiculo.values, formSinistro?.values, formCliente.values, anexos.files)"
    *ngIf="stepper.selectedIndex === stepper.steps.length -1">
    Salvar atendimento
  </button>
</div>